(function () {
  var STEP_COLLECTION_FALLBACKS = {
    'shower-gel': ['shower-gel', 'skincare-y-belleza-para-cuerpo-shower-gel'],
    'body-lotion': ['body-lotion', 'skincare-y-belleza-para-cuerpo-body-lotion'],
    'hair-and-body-oil': ['hair-and-body-oil', 'skincare-y-belleza-para-cuerpo-hair-and-body-oil'],
    'hair-body-oil': ['hair-and-body-oil', 'skincare-y-belleza-para-cuerpo-hair-and-body-oil'],
    'body-mist': ['body-mist', 'skincare-y-belleza-para-cuerpo-body-mist']
  };

  var STEP_SEARCH_QUERIES = {
    'shower-gel': 'gel de ducha',
    'body-lotion': 'crema corporal',
    'hair-and-body-oil': 'aceite cabello cuerpo',
    'hair-body-oil': 'aceite cabello cuerpo',
    'body-mist': 'fragancia corporal'
  };

  var STEP_PRODUCT_MATCH = {
    'shower-gel': [/gel de ducha/i, /shower gel/i],
    'body-lotion': [/crema corporal/i, /body lotion/i],
    'hair-and-body-oil': [/aceite para cabello/i, /hair.*body.*oil/i, /hair & body oil/i],
    'hair-body-oil': [/aceite para cabello/i, /hair.*body.*oil/i, /hair & body oil/i],
    'body-mist': [/fragancia corporal/i, /body mist/i]
  };

  var ADVISOR_STEPS = ['skin', 'goal', 'moment', 'scent'];

  var SCENT_KEYWORDS = {
    citrus: ['citrico', 'cítrico', 'mandarina', 'limon', 'limón', 'limoncillo', 'naranja', 'citrus', 'bergamota'],
    floral: ['floral', 'jazmin', 'jazmín', 'loto', 'geranio', 'rosa', 'lavanda', 'flores'],
    herbal: ['herbal', 'herbales', 'menta', 'romero', 'oregano', 'orégano', 'albahaca', 'eucalipto', 'tomillo'],
    woody: ['amaderado', 'amaderados', 'incienso', 'cedro', 'sandalo', 'sándalo', 'especia', 'especias', 'canela', 'pachuli']
  };

  var SCENT_STEP_BONUS = {
    'shower-gel': { citrus: 2, herbal: 1 },
    'body-lotion': { floral: 2, woody: 1 },
    'hair-and-body-oil': { woody: 2, herbal: 1 },
    'hair-body-oil': { woody: 2, herbal: 1 },
    'body-mist': { citrus: 3, floral: 3, woody: 2, herbal: 1 }
  };

  var ROUTINE_PROFILES = {
    hydrating: {
      title: 'Rutina hidratante profunda',
      summary: 'Tu piel pide más humedad y nutrición. Prioriza sellar la hidratación después del baño y un toque aromático suave al final.',
      weights: { dry: 3, hydration: 3, nourish: 2, night: 1, shower: 2 },
      starHandles: ['body-lotion', 'hair-and-body-oil', 'hair-body-oil'],
      tips: {
        'shower-gel': 'Limpia sin resecar; evita agua muy caliente.',
        'body-lotion': 'Aplica sobre piel limpia y seca con masaje hasta absorción.',
        'hair-and-body-oil': '3–5 gotas en piel; 1–3 gotas en puntas del cabello.',
        'hair-body-oil': '3–5 gotas en piel; 1–3 gotas en puntas del cabello.',
        'body-mist': 'Cierra con una niebla ligera para sentir frescura.'
      }
    },
    balanced: {
      title: 'Rutina equilibrio diario',
      summary: 'Buscas constancia sin complicarte. Los cuatro pasos en orden te dan limpieza, hidratación y un cierre fresco.',
      weights: { oily: 2, combo: 3, balance: 3, morning: 2, shower: 2 },
      starHandles: ['shower-gel', 'body-lotion'],
      tips: {
        'shower-gel': 'Tu base: limpia sin agredir la barrera de la piel.',
        'body-lotion': 'Equilibra sin sensación pesada.',
        'hair-and-body-oil': 'Opcional en zonas más secas.',
        'hair-body-oil': 'Opcional en zonas más secas.',
        'body-mist': 'El toque final que hace la rutina memorable.'
      }
    },
    aromatic: {
      title: 'Rutina aromática y fresca',
      summary: 'Quieres sentirte bien y que el aroma acompañe tu día. El body mist es tu aliado estrella.',
      weights: { aroma: 4, morning: 2, night: 2, active: 1, citrus: 2, floral: 2 },
      starHandles: ['body-mist'],
      tips: {
        'shower-gel': 'Prepara la piel para absorber mejor lo que sigue.',
        'body-lotion': 'Capa ligera antes del aroma.',
        'hair-and-body-oil': 'Aporta luminosidad sin opacar el perfume.',
        'hair-body-oil': 'Aporta luminosidad sin opacar el perfume.',
        'body-mist': 'Rocía 3–6 veces a 15–20 cm de la piel.'
      }
    },
    nourishing: {
      title: 'Rutina nutritiva piel y cabello',
      summary: 'Necesitas nutrir en profundidad. El aceite corporal y capilar es el paso clave de tu rutina.',
      weights: { nourish: 4, dry: 2, night: 2, shower: 1 },
      starHandles: ['hair-and-body-oil', 'hair-body-oil', 'body-lotion'],
      tips: {
        'shower-gel': 'Limpieza suave antes de nutrir.',
        'body-lotion': 'Primera capa de hidratación.',
        'hair-and-body-oil': '3–5 gotas en piel; 1–3 en puntas del cabello.',
        'hair-body-oil': '3–5 gotas en piel; 1–3 en puntas del cabello.',
        'body-mist': 'Sella con frescura sin resecar.'
      }
    },
    gentle: {
      title: 'Rutina suave para piel sensible',
      summary: 'Tu piel es reactiva: menos es más. Rutina constante, productos suaves y sin saltarte la hidratación.',
      weights: { sensitive: 4, balance: 2, hydration: 2, night: 1, floral: 1, herbal: 1 },
      starHandles: ['body-lotion', 'shower-gel'],
      tips: {
        'shower-gel': 'Fórmula suave; evita frotar con fuerza.',
        'body-lotion': 'Hidrata siempre; es tu mejor aliado.',
        'hair-and-body-oil': 'Prueba primero en una zona pequeña.',
        'hair-body-oil': 'Prueba primero en una zona pequeña.',
        'body-mist': 'Aroma ligero; no abuses la cantidad.'
      }
    },
    active: {
      title: 'Rutina post-actividad',
      summary: 'Después del movimiento necesitas frescura y recuperación. Limpia, hidrata y revive con aroma.',
      weights: { active: 4, aroma: 2, shower: 2, oily: 1 },
      starHandles: ['shower-gel', 'body-mist'],
      tips: {
        'shower-gel': 'Esencial después de sudar.',
        'body-lotion': 'Recupera la humedad perdida.',
        'hair-and-body-oil': 'Calma zonas resecas por el clima o el ejercicio.',
        'hair-body-oil': 'Calma zonas resecas por el clima o el ejercicio.',
        'body-mist': 'Frescura instantánea antes de continuar el día.'
      }
    }
  };

  function parseConfig(section) {
    var el = section.querySelector('[data-skincare-steps-config]');
    if (!el) return { steps: [], analyticsPrefix: 'inicio' };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { steps: [], analyticsPrefix: 'inicio' };
    }
  }

  function getAnalyticsPrefix(section, config) {
    var fromSection = section && section.getAttribute('data-analytics-prefix');
    if (fromSection) return fromSection.trim() || 'inicio';
    if (config && config.analyticsPrefix) return config.analyticsPrefix;
    return 'inicio';
  }

  function pushAdvisorComplete(prefix, answers, profileTitle) {
    var eventName = prefix + '_rutina_asesor_completar';
    var extra = {
      skincare_skin: answers.skin || '',
      skincare_goal: answers.goal || '',
      skincare_moment: answers.moment || '',
      skincare_scent: answers.scent || '',
      skincare_profile: profileTitle || ''
    };

    if (typeof window.pushOleumEventoclick === 'function') {
      window.pushOleumEventoclick(eventName, extra);
      return;
    }

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(Object.assign({ event: 'eventoclick', eventoclick: eventName }, extra));
    }
  }

  function scoreProfile(profile, answers) {
    var score = 0;
    var weights = profile.weights || {};
    Object.keys(weights).forEach(function (key) {
      if (
        answers.skin === key ||
        answers.goal === key ||
        answers.moment === key ||
        answers.scent === key
      ) {
        score += weights[key];
      }
    });
    return score;
  }

  function pickRoutine(answers) {
    var best = 'balanced';
    var bestScore = -1;
    Object.keys(ROUTINE_PROFILES).forEach(function (key) {
      var s = scoreProfile(ROUTINE_PROFILES[key], answers);
      if (s > bestScore) {
        bestScore = s;
        best = key;
      }
    });
    return ROUTINE_PROFILES[best];
  }

  function detectProductScents(searchText) {
    var text = String(searchText || '').toLowerCase();
    var found = [];
    Object.keys(SCENT_KEYWORDS).forEach(function (scent) {
      SCENT_KEYWORDS[scent].some(function (kw) {
        if (text.indexOf(kw) !== -1) {
          found.push(scent);
          return true;
        }
        return false;
      });
    });
    return found;
  }

  function scoreProduct(product, step, answers, profile) {
    if (!product) return -1;
    var score = 0;
    var handle = step.handle || '';
    var scents = detectProductScents(product.searchText || product.title || '');

    if (answers.scent) {
      if (scents.indexOf(answers.scent) !== -1) score += 12;
      var stepBonus = SCENT_STEP_BONUS[handle];
      if (stepBonus && stepBonus[answers.scent]) score += stepBonus[answers.scent];
    }

    if (answers.goal === 'aroma' && (handle === 'body-mist' || handle.indexOf('mist') !== -1)) score += 6;
    if (answers.goal === 'nourish' && (handle.indexOf('oil') !== -1 || handle === 'body-lotion')) score += 4;
    if (answers.goal === 'hydration' && handle === 'body-lotion') score += 5;
    if (answers.skin === 'sensitive' && (handle === 'shower-gel' || handle === 'body-lotion')) score += 3;
    if (answers.skin === 'oily' && handle === 'shower-gel') score += 3;
    if (answers.moment === 'active' && (handle === 'shower-gel' || handle === 'body-mist')) score += 3;
    if (handleMatchesStar(handle, profile.starHandles)) score += 2;
    if (product.available === false) score -= 20;

    return score;
  }

  function pickProductForStep(step, answers, profile) {
    var products = step.products || [];
    var fallback = {
      title: step.productTitle,
      url: step.url,
      image: step.productImage,
      price: step.productPrice,
      variantId: step.variantId,
      productId: step.productId,
      available: step.available,
      searchText: step.productTitle || step.label || ''
    };

    if (!products.length) {
      return fallback;
    }

    var best = null;
    var bestScore = -999;
    products.forEach(function (product) {
      var s = scoreProduct(product, step, answers, profile);
      if (s > bestScore) {
        bestScore = s;
        best = product;
      }
    });

    if (!best && products.length) best = products[0];
    return best || fallback;
  }

  function formatAjaxPrice(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'MXN' }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function normalizeProductPrice(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) return '';
    if (n >= 1000 && Number.isInteger(n)) n = n / 100;
    return formatAjaxPrice(n);
  }

  function mapCollectionProduct(p) {
    var v = p.variants && p.variants.length ? p.variants[0] : null;
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '');
    return {
      title: p.title,
      url: '/products/' + p.handle,
      image: p.featured_image || (p.images && p.images[0]) || '',
      price: v && v.price != null ? normalizeProductPrice(v.price) : '',
      variantId: v ? v.id : null,
      productId: p.id,
      available: v ? v.available !== false : p.available !== false,
      searchText: (p.title + ' ' + tags + ' ' + (p.product_type || p.type || '')).toLowerCase()
    };
  }

  function mapProductJs(p) {
    if (!p) return null;
    var v = p.variants && p.variants.length ? p.variants[0] : null;
    var image = p.featured_image || (p.images && p.images[0]) || '';
    if (image && typeof image === 'object' && image.src) image = image.src;
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '');
    return {
      title: p.title,
      url: '/products/' + p.handle,
      image: image,
      price: v && v.price != null ? normalizeProductPrice(v.price) : normalizeProductPrice(p.price),
      variantId: v ? v.id : null,
      productId: p.id,
      available: v ? v.available !== false : p.available !== false,
      searchText: (p.title + ' ' + tags + ' ' + (p.type || '')).toLowerCase()
    };
  }

  function isBundleTitle(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('duo ') === 0 || t.indexOf('kit ') === 0 || t.indexOf('kit de') === 0 || t.indexOf('kit ciudado') === 0;
  }

  function matchesStepProduct(title, stepHandle) {
    var patterns = STEP_PRODUCT_MATCH[stepHandle] || [];
    if (!patterns.length) return true;
    return patterns.some(function (re) {
      return re.test(title || '');
    });
  }

  function filterRoutineProducts(products, stepHandle) {
    var list = products || [];
    var matched = list.filter(function (p) {
      return matchesStepProduct(p.title, stepHandle);
    });
    var singles = matched.filter(function (p) {
      return !isBundleTitle(p.title);
    });
    if (singles.length) return singles;
    if (matched.length) return matched;
    return list.filter(function (p) {
      return !isBundleTitle(p.title);
    });
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Producto no encontrado');
        return res.json();
      })
      .then(mapProductJs)
      .catch(function () {
        return null;
      });
  }

  function fetchSearchProducts(query, limit) {
    if (!query) return Promise.resolve([]);
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' +
      (limit || 12);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Búsqueda fallida');
        return res.json();
      })
      .then(function (data) {
        var hits = (data.resources && data.resources.results && data.resources.results.products) || [];
        return Promise.all(
          hits.map(function (hit) {
            return fetchProductByHandle(hit.handle);
          })
        );
      })
      .then(function (items) {
        return items.filter(Boolean);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCollectionProductsOnce(handle) {
    if (!handle) return Promise.resolve([]);

    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=30', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('No se pudo cargar la colección');
        return res.json();
      })
      .then(function (data) {
        return (data.products || []).map(mapCollectionProduct);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCollectionProducts(handle, stepHandle) {
    var handles = [handle];
    var stepKey = stepHandle || handle;
    if (STEP_COLLECTION_FALLBACKS[stepKey]) {
      handles = handles.concat(STEP_COLLECTION_FALLBACKS[stepKey]);
    }
    handles = handles.filter(function (h, i, arr) {
      return h && arr.indexOf(h) === i;
    });

    var chain = Promise.resolve([]);
    handles.forEach(function (h) {
      chain = chain.then(function (acc) {
        if (acc.length) return acc;
        return fetchCollectionProductsOnce(h);
      });
    });

    return chain.then(function (products) {
      if (products.length) return products;
      var query = STEP_SEARCH_QUERIES[stepKey] || String(stepKey || handle).replace(/-/g, ' ');
      return fetchSearchProducts(query, 16);
    });
  }

  function stepNeedsCatalog(step) {
    if (!step.products || !step.products.length) return true;
    return !step.products.some(function (p) {
      return p && p.variantId;
    });
  }

  function enrichStepCatalog(step) {
    if (!stepNeedsCatalog(step)) {
      return Promise.resolve(step);
    }

    var handle = step.collectionHandle || step.handle;
    return fetchCollectionProducts(handle, step.handle).then(function (products) {
      products = filterRoutineProducts(products, step.handle);
      if (products.length) {
        step.products = products;
        if (!step.variantId && products[0].variantId) {
          step.variantId = products[0].variantId;
          step.available = products[0].available;
          if (!step.productTitle || step.productTitle === step.label) {
            step.productTitle = products[0].title;
          }
          if (!step.productPrice) step.productPrice = products[0].price;
          if (!step.productImage) step.productImage = products[0].image;
          if (!step.url) step.url = products[0].url;
        }
      }
      return step;
    });
  }

  function enrichAllSteps(steps) {
    return Promise.all((steps || []).map(enrichStepCatalog));
  }

  function resolveVariantId(step, picked) {
    if (picked && picked.variantId) return picked.variantId;
    if (step.variantId) return step.variantId;
    return null;
  }

  function buildRoutineSteps(configSteps, answers, profile) {
    return (configSteps || []).map(function (step) {
      var picked = pickProductForStep(step, answers, profile);
      return {
        step: step,
        picked: picked,
        isStar: handleMatchesStar(step.handle, profile.starHandles)
      };
    });
  }

  function handleMatchesStar(handle, stars) {
    if (!handle) return false;
    return stars.some(function (s) {
      return handle === s || handle.indexOf(s) === 0;
    });
  }

  function getTip(profile, handle, label) {
    if (profile.tips[handle]) return profile.tips[handle];
    var keys = Object.keys(profile.tips);
    for (var i = 0; i < keys.length; i++) {
      if (handle && (handle.indexOf(keys[i]) !== -1 || keys[i].indexOf(handle) !== -1)) {
        return profile.tips[keys[i]];
      }
    }
    return 'Inclúyelo en tu rutina diaria para mejores resultados.';
  }

  function cartAddUrl() {
    var base =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
      (window.routes && window.routes.cart_add_url) ||
      '/cart/add';
    return base.indexOf('.js') !== -1 ? base : base + '.js';
  }

  function fetchCart() {
    var cartBase =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) ||
      (window.routes && window.routes.cart_url) ||
      '/cart';
    var cartUrl = cartBase.indexOf('.js') !== -1 ? cartBase : cartBase.replace(/\/$/, '') + '.js';
    return fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function uniqueVariantIds(variantIds) {
    var unique = [];
    (variantIds || []).forEach(function (id) {
      if (!id) return;
      var num = Number(id);
      if (unique.indexOf(num) === -1) unique.push(num);
    });
    return unique;
  }

  function addSingleVariantToCart(variantId) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && data.status)) {
          throw new Error((data && data.description) || 'No se pudo añadir al carrito.');
        }
        return data;
      });
    });
  }

  function addVariantsSequentially(variantIds) {
    var added = 0;
    var chain = Promise.resolve();

    variantIds.forEach(function (id) {
      chain = chain.then(function () {
        return addSingleVariantToCart(id)
          .then(function () {
            added += 1;
          })
          .catch(function () {
            /* ya en carrito o sin stock: continuar con el resto */
          });
      });
    });

    return chain.then(function () {
      if (!added) {
        throw new Error('No se pudo añadir ningún producto. Puede que ya estén en tu bolsa.');
      }
      return fetchCart().then(function (cart) {
        cart._addedCount = added;
        cart._skippedCount = 0;
        return cart;
      });
    });
  }

  function addVariantsToCart(variantIds) {
    var uniqueIds = uniqueVariantIds(variantIds);
    if (!uniqueIds.length) {
      return Promise.reject(new Error('Sin productos'));
    }

    return fetchCart().then(function (cart) {
      var inCart = {};
      (cart.items || []).forEach(function (item) {
        inCart[item.variant_id] = item.quantity;
      });

      var toAdd = uniqueIds.filter(function (id) {
        return !inCart[id];
      });
      var skipped = uniqueIds.length - toAdd.length;

      if (!toAdd.length) {
        var allInCart = new Error('Ya tienes todos los productos de esta rutina en tu bolsa.');
        allInCart.code = 'ALL_IN_CART';
        allInCart._skippedCount = skipped;
        throw allInCart;
      }

      var items = toAdd.map(function (id) {
        return { id: id, quantity: 1 };
      });

      return fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || (data && data.status)) {
            return addVariantsSequentially(toAdd).then(function (result) {
              result._skippedCount = (result._skippedCount || 0) + skipped;
              return result;
            });
          }
          return fetchCart().then(function (cart) {
            cart._addedCount = toAdd.length;
            cart._skippedCount = skipped;
            return cart;
          });
        });
      });
    });
  }

  function checkoutUrl() {
    var base = (window.shopUrl || window.location.origin || '').replace(/\/$/, '');
    return (base + '/checkout').replace(/([^:]\/)\/+/g, '$1');
  }

  function syncCartAfterAdd(result) {
    var count = result && typeof result.item_count === 'number' ? result.item_count : undefined;
    if (typeof window.refreshOleumCartUI === 'function') {
      return window.refreshOleumCartUI(count);
    }
    return Promise.resolve(result);
  }

  var ADVISOR_TOAST_MS = 5000;
  var advisorToastTimers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function hideAdvisorToast(root) {
    if (!root) return;
    var dialog = root.closest('[data-skincare-step-dialog]') || root.closest('dialog');
    var toast =
      (dialog && dialog.querySelector('[data-skincare-advisor-toast]')) ||
      root.querySelector('[data-skincare-advisor-toast]');
    if (!toast) return;

    if (advisorToastTimers) {
      var timer = advisorToastTimers.get(root);
      if (timer) {
        window.clearTimeout(timer);
        advisorToastTimers.delete(root);
      }
    } else if (root._advisorToastTimer) {
      window.clearTimeout(root._advisorToastTimer);
      root._advisorToastTimer = null;
    }

    toast.classList.remove('is-visible');
    root.classList.remove('is-advisor-toast-visible');
    window.setTimeout(function () {
      if (!toast.classList.contains('is-visible')) {
        toast.hidden = true;
      }
    }, 260);
  }

  function showAdvisorToast(root, title, detail) {
    if (!root) return;
    var toast = root.querySelector('[data-skincare-advisor-toast]');
    var msgEl = toast && toast.querySelector('[data-skincare-advisor-toast-msg]');
    if (!toast || !msgEl) return;

    hideAdvisorToast(root);

    msgEl.innerHTML =
      '<strong>' +
      title +
      '</strong>' +
      (detail ? '<span>' + detail + '</span>' : '');

    /* Colgar del <dialog> (top layer) para pintar fuera del panel, arriba a la derecha. */
    var dialog = root.closest('[data-skincare-step-dialog]') || root.closest('dialog');
    if (dialog && toast.parentNode !== dialog) {
      dialog.appendChild(toast);
    }

    toast.classList.add('is-page-toast');
    toast.hidden = false;
    root.classList.add('is-advisor-toast-visible');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    var timer = window.setTimeout(function () {
      hideAdvisorToast(root);
    }, ADVISOR_TOAST_MS);

    if (advisorToastTimers) {
      advisorToastTimers.set(root, timer);
    } else {
      root._advisorToastTimer = timer;
    }
  }

  function resetAdvisorCartUi(root) {
    if (!root) return;
    var addBtn = root.querySelector('[data-skincare-advisor-add-cart]');
    if (addBtn) {
      addBtn.hidden = false;
      addBtn.disabled = false;
    }
  }

  function showAdvisorCartSuccess(root, title, detail) {
    if (!root) return;
    var checkoutLink = root.querySelector('[data-skincare-advisor-checkout]');
    var cartWrap = root.querySelector('[data-skincare-advisor-cart]');
    if (cartWrap) cartWrap.hidden = false;
    if (checkoutLink) checkoutLink.href = checkoutUrl();
    showAdvisorToast(root, title, detail);
  }

  function buildCartAddedCopy(result) {
    var added = result && result._addedCount;
    var skipped = result && result._skippedCount;
    var title = '¡Rutina añadida a la bolsa!';
    var detail = 'Tu rutina se agregó al carrito con éxito.';

    if (added && skipped) {
      title =
        'Se añadieron ' +
        added +
        ' producto' +
        (added > 1 ? 's' : '') +
        ' a la bolsa';
      detail =
        skipped +
        ' producto' +
        (skipped > 1 ? 's ya estaban' : ' ya estaba') +
        ' en tu carrito.';
    } else if (added && added !== 1) {
      title = 'Se añadieron ' + added + ' productos a la bolsa';
    }

    return { title: title, detail: detail };
  }

  function notifyCartAdded(root, result) {
    var copy = buildCartAddedCopy(result);
    return syncCartAfterAdd(result).then(function () {
      showAdvisorCartSuccess(root, copy.title, copy.detail);
    });
  }

  function scrollAdvisorToTop(root) {
    var scrollEl = root && root.closest('[data-skincare-step-dialog-body]');
    if (scrollEl) scrollEl.scrollTop = 0;
  }

  function bindDialogActions(section, dialog, dialogBody, triggers, openFromTrigger, openAdvisor) {
    dialog.addEventListener('click', function (e) {
      var nextBtn = e.target.closest('[data-skincare-step-next]');
      if (nextBtn) {
        e.preventDefault();
        var idx = parseInt(dialogBody.dataset.currentStepIndex, 10);
        if (!isNaN(idx) && triggers[idx + 1]) {
          openFromTrigger(triggers[idx + 1]);
        }
        return;
      }

      var advisorBtn = e.target.closest('[data-skincare-advisor-open]');
      if (advisorBtn) {
        e.preventDefault();
        openAdvisor();
      }
    });
  }

  function initAdvisor(section, dialog, dialogBody, triggers) {
    function getAdvisorTemplate() {
      return section.querySelector('[id^="skincare-advisor-"]');
    }

    var config = parseConfig(section);
    var analyticsPrefix = getAnalyticsPrefix(section, config);

    var state = {
      stepIndex: 0,
      answers: { skin: '', goal: '', moment: '', scent: '' },
      advancing: false,
      advanceTimer: null
    };

    function goToStep(root, nextIndex) {
      if (state.advanceTimer) {
        window.clearTimeout(state.advanceTimer);
        state.advanceTimer = null;
      }
      state.advancing = false;
      state.stepIndex = nextIndex;
      root.querySelectorAll('[data-skincare-advisor-step]').forEach(function (s, i) {
        s.classList.toggle('is-active', i === nextIndex);
      });
      updateAdvisorUI(root);
    }

    function handleAnswer(root, input) {
      if (!input || input.type !== 'radio') return;
      var name = input.name;
      if (!name || state.advancing) return;

      state.answers[name] = input.value;
      root.querySelectorAll('.oleum-skincare-steps__advisor-option').forEach(function (o) {
        o.classList.toggle('is-selected', !!o.querySelector('input:checked'));
      });
      updateAdvisorUI(root);

      state.advancing = true;
      state.advanceTimer = window.setTimeout(function () {
        state.advanceTimer = null;
        if (state.stepIndex < ADVISOR_STEPS.length - 1) {
          goToStep(root, state.stepIndex + 1);
        } else {
          showAdvisorResult(root);
        }
        state.advancing = false;
      }, 320);
    }

    function resetAdvisor(root) {
      if (!root) return;
      if (state.advanceTimer) {
        window.clearTimeout(state.advanceTimer);
        state.advanceTimer = null;
      }
      state.stepIndex = 0;
      state.answers = { skin: '', goal: '', moment: '', scent: '' };
      state.advancing = false;
      root.querySelectorAll('[data-skincare-advisor-step]').forEach(function (s, i) {
        s.classList.toggle('is-active', i === 0);
      });
      root.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = false;
      });
      root.querySelectorAll('.oleum-skincare-steps__advisor-option').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      var form = root.querySelector('[data-skincare-advisor-form]');
      var result = root.querySelector('[data-skincare-advisor-result]');
      if (form) form.hidden = false;
      if (result) {
        result.hidden = true;
        result.classList.remove('is-visible');
      }
      root.classList.remove('is-result');
      root.classList.add('is-advisor-step-first');
      var headTitle = root.querySelector('.oleum-skincare-steps__dialog-title');
      if (headTitle && headTitle.dataset.defaultTitle) {
        headTitle.textContent = headTitle.dataset.defaultTitle;
      }
      var cartWrap = root.querySelector('[data-skincare-advisor-cart]');
      if (cartWrap) cartWrap.hidden = true;
      resetAdvisorCartUi(root);
      hideAdvisorToast(root);
      updateAdvisorUI(root);
    }

    function updateAdvisorUI(root) {
      var progress = root.querySelector('[data-skincare-advisor-progress]');
      var backBtn = root.querySelector('[data-skincare-advisor-back]');
      var restartBtn = root.querySelector('[data-skincare-advisor-restart]');
      var restartWrap = root.querySelector('[data-skincare-advisor-restart-wrap]');
      var nav = root.querySelector('[data-skincare-advisor-nav]');
      var activeKey = ADVISOR_STEPS[state.stepIndex];
      var answered = !!state.answers[activeKey];
      var isResult = root.classList.contains('is-result');

      if (progress) {
        progress.style.width = Math.round(((state.stepIndex + (answered ? 1 : 0)) / ADVISOR_STEPS.length) * 100) + '%';
      }
      if (backBtn) {
        backBtn.hidden = isResult || state.stepIndex === 0;
      }
      if (restartWrap) {
        restartWrap.hidden = !isResult;
      }
      if (restartBtn) {
        restartBtn.hidden = !isResult;
      }
      if (nav) {
        nav.hidden = isResult || state.stepIndex === 0;
      }
      root.classList.toggle('is-advisor-step-first', !isResult && state.stepIndex === 0);
    }

    function renderAdvisorResult(root, profile, routineSteps) {
      var titleEl = root.querySelector('[data-skincare-advisor-result-title]');
      var textEl = root.querySelector('[data-skincare-advisor-result-text]');
      var stepsEl = root.querySelector('[data-skincare-advisor-result-steps]');
      var cartWrap = root.querySelector('[data-skincare-advisor-cart]');
      var cartNote = root.querySelector('[data-skincare-advisor-cart-note]');
      var variantIds = [];
      var scentLabel = {
        citrus: 'cítrico',
        floral: 'floral',
        herbal: 'herbal',
        woody: 'amaderado'
      };

      var summary = profile.summary;
      if (state.answers.scent && scentLabel[state.answers.scent]) {
        summary += ' Te sugerimos la línea ' + scentLabel[state.answers.scent] + ' en los cuatro pasos.';
      }
      if (titleEl) titleEl.textContent = profile.title;
      if (textEl) textEl.textContent = summary;

      if (stepsEl) {
        stepsEl.innerHTML = '';
        routineSteps.forEach(function (entry) {
          var step = entry.step;
          var picked = entry.picked;
          var isStar = entry.isStar;
          var li = document.createElement('li');
          li.className = 'oleum-skincare-steps__advisor-step-card' + (isStar ? ' is-star' : '');

          var inner = document.createElement('div');
          inner.className = 'oleum-skincare-steps__advisor-step-card-inner';

          var imageSrc = (picked && picked.image) || step.productImage;
          if (imageSrc) {
            var media = document.createElement('div');
            media.className = 'oleum-skincare-steps__advisor-step-card-media';
            var img = document.createElement('img');
            img.src = imageSrc;
            img.alt = (picked && picked.title) || step.productTitle || step.label || '';
            img.loading = 'lazy';
            img.width = 72;
            img.height = 72;
            media.appendChild(img);
            inner.appendChild(media);
          }

          var body = document.createElement('div');
          body.className = 'oleum-skincare-steps__advisor-step-card-body';

          var productName = (picked && picked.title) || step.productTitle || step.label || '';
          var label = document.createElement('p');
          label.className = 'oleum-skincare-steps__advisor-step-label';
          label.textContent = 'Paso ' + step.number + ' · ' + productName;
          if (isStar) label.textContent += ' ★';

          var tip = document.createElement('p');
          tip.className = 'oleum-skincare-steps__advisor-step-tip';
          tip.textContent = getTip(profile, step.handle, step.label);

          body.appendChild(label);
          body.appendChild(tip);

          var meta = document.createElement('div');
          meta.className = 'oleum-skincare-steps__advisor-step-meta';

          var priceText = picked && picked.price ? picked.price : step.productPrice;
          if (priceText) {
            var price = document.createElement('p');
            price.className = 'oleum-skincare-steps__advisor-step-price';
            price.textContent = priceText;
            meta.appendChild(price);
          }

          var linkUrl = (picked && picked.url) || step.url;
          if (linkUrl) {
            var link = document.createElement('a');
            link.className = 'oleum-skincare-steps__advisor-step-link';
            link.href = linkUrl;
            link.textContent = (config && config.productLinkCta) || 'Explorar';
            if (step.handle) {
              link.setAttribute('data-eventoclick', analyticsPrefix + '_rutina_asesor_ver_' + step.handle);
            } else {
              link.setAttribute('data-eventoclick', analyticsPrefix + '_rutina_asesor_ver_paso' + step.number);
            }
            meta.appendChild(link);
          }

          if (meta.childNodes.length) body.appendChild(meta);
          inner.appendChild(body);
          li.appendChild(inner);
          stepsEl.appendChild(li);

          var variantId = resolveVariantId(step, picked);
          if (variantId && variantIds.indexOf(variantId) === -1) {
            variantIds.push(variantId);
          }
        });
      }

      if (cartWrap) {
        var addCartBtn = root.querySelector('[data-skincare-advisor-add-cart]');
        resetAdvisorCartUi(root);
        if (variantIds.length > 0) {
          cartWrap.hidden = false;
          cartWrap.dataset.variantIds = variantIds.join(',');
          if (addCartBtn) addCartBtn.hidden = false;
          if (cartNote) {
            cartNote.textContent =
              variantIds.length === 1
                ? '1 producto listo para tu bolsa'
                : variantIds.length + ' productos de tu rutina personalizada';
          }
        } else {
          cartWrap.hidden = false;
          delete cartWrap.dataset.variantIds;
          if (addCartBtn) addCartBtn.hidden = true;
          if (cartNote) {
            cartNote.textContent = 'No encontramos productos disponibles para agregar. Revisa las colecciones de cada paso.';
          }
        }
      }

      scrollAdvisorToTop(root);

      try {
        localStorage.setItem(
          'oleum_skincare_routine',
          JSON.stringify({ answers: state.answers, profile: profile.title, at: Date.now() })
        );
      } catch (err) { /* ignore */ }

      pushAdvisorComplete(analyticsPrefix, state.answers, profile.title);
    }

    function showAdvisorResult(root) {
      var profile = pickRoutine(state.answers);
      var form = root.querySelector('[data-skincare-advisor-form]');
      var result = root.querySelector('[data-skincare-advisor-result]');
      var stepsEl = root.querySelector('[data-skincare-advisor-result-steps]');
      var cartWrap = root.querySelector('[data-skincare-advisor-cart]');

      root.classList.add('is-result');
      root.classList.remove('is-advisor-step-first');
      var headTitle = root.querySelector('.oleum-skincare-steps__dialog-title');
      if (headTitle) {
        if (!headTitle.dataset.defaultTitle) {
          headTitle.dataset.defaultTitle = headTitle.textContent;
        }
        headTitle.textContent = profile.title;
      }
      if (form) form.hidden = true;
      if (result) {
        result.hidden = false;
        result.classList.add('is-visible');
      }
      if (cartWrap) cartWrap.hidden = true;
      updateAdvisorUI(root);

      if (stepsEl) {
        stepsEl.innerHTML =
          '<li class="oleum-skincare-steps__advisor-step-card" style="grid-column:1/-1;padding:12px 0;"><p class="oleum-skincare-steps__advisor-step-tip" style="margin:0;text-align:center;">Cargando productos recomendados…</p></li>';
      }

      enrichAllSteps(config.steps || []).then(function () {
        var routineSteps = buildRoutineSteps(config.steps, state.answers, profile);
        renderAdvisorResult(root, profile, routineSteps);
      });
    }

    function bindAdvisor(root) {
      if (!root) return;

      root.addEventListener('click', function (e) {
        var option = e.target.closest('.oleum-skincare-steps__advisor-option');
        if (!option || !root.contains(option) || state.advancing) return;

        var input = option.querySelector('input[type="radio"]');
        if (!input) return;

        window.setTimeout(function () {
          if (input.checked) handleAnswer(root, input);
        }, 0);
      });

      var backBtn = root.querySelector('[data-skincare-advisor-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (root.classList.contains('is-result')) {
            root.classList.remove('is-result');
            var formEl = root.querySelector('[data-skincare-advisor-form]');
            var resultEl = root.querySelector('[data-skincare-advisor-result]');
            if (formEl) formEl.hidden = false;
            if (resultEl) {
              resultEl.hidden = true;
              resultEl.classList.remove('is-visible');
            }
            var head = root.querySelector('.oleum-skincare-steps__dialog-title');
            if (head && head.dataset.defaultTitle) head.textContent = head.dataset.defaultTitle;
            goToStep(root, ADVISOR_STEPS.length - 1);
            return;
          }
          if (state.stepIndex > 0) {
            goToStep(root, state.stepIndex - 1);
          }
        });
      }

      var restartBtn = root.querySelector('[data-skincare-advisor-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          resetAdvisor(root);
        });
      }

      var toastCloseBtn = root.querySelector('[data-skincare-advisor-toast-close]');
      if (toastCloseBtn) {
        toastCloseBtn.addEventListener('click', function () {
          hideAdvisorToast(root);
        });
      }

      var addCartBtn = root.querySelector('[data-skincare-advisor-add-cart]');
      if (addCartBtn) {
        addCartBtn.addEventListener('click', function () {
          var wrap = root.querySelector('[data-skincare-advisor-cart]');
          var raw = wrap && wrap.dataset.variantIds;
          if (!raw || addCartBtn.disabled) return;

          var ids = raw.split(',').filter(Boolean);
          addCartBtn.disabled = true;
          addVariantsToCart(ids)
            .then(function (result) {
              return notifyCartAdded(root, result);
            })
            .catch(function (err) {
              if (err && err.code === 'ALL_IN_CART') {
                return syncCartAfterAdd().then(function () {
                  showAdvisorCartSuccess(
                    root,
                    'Tu rutina ya está en la bolsa',
                    'Todos los productos recomendados ya están en tu carrito.'
                  );
                });
              }
              if (typeof window.showCartToast === 'function') {
                window.showCartToast(
                  err && err.message ? err.message : 'No se pudo añadir la rutina. Intenta de nuevo.',
                  'error'
                );
              }
            })
            .finally(function () {
              var btn = root.querySelector('[data-skincare-advisor-add-cart]');
              if (btn) btn.disabled = false;
            });
        });
      }

      var keepShoppingBtn = root.querySelector('[data-skincare-advisor-keep-shopping]');
      if (keepShoppingBtn) {
        keepShoppingBtn.addEventListener('click', function () {
          var dialog = root.closest('[data-skincare-step-dialog]');
          if (dialog && typeof dialog.close === 'function') dialog.close();
        });
      }
    }

    function openAdvisor() {
      var tpl = getAdvisorTemplate();
      if (!tpl) return;

      dialogBody.innerHTML = '';
      if (tpl.tagName === 'TEMPLATE' && tpl.content) {
        dialogBody.appendChild(tpl.content.cloneNode(true));
      } else {
        dialogBody.innerHTML = tpl.innerHTML;
      }

      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      dialogBody.dataset.currentStepIndex = 'advisor';

      var root = dialogBody.querySelector('[data-skincare-advisor]');
      resetAdvisor(root);
      bindAdvisor(root);

      if (!dialog.open && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    return { openAdvisor: openAdvisor };
  }

  function initSection(section) {
    if (!section || section.dataset.stepsModalInit) return;
    section.dataset.stepsModalInit = '1';

    var dialog = section.querySelector('[data-skincare-step-dialog]');
    var dialogBody = section.querySelector('[data-skincare-step-dialog-body]');
    var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-skincare-step-trigger]'));
    if (!dialog || !dialogBody) return;

    var lastTrigger = null;
    var advisorApi = initAdvisor(section, dialog, dialogBody, triggers);

    function openFromTrigger(btn) {
      var templateId = btn.getAttribute('aria-controls');
      var template = templateId ? section.querySelector('#' + CSS.escape(templateId)) : null;
      if (!template) return;

      dialogBody.innerHTML = '';
      if (template.tagName === 'TEMPLATE' && template.content) {
        dialogBody.appendChild(template.content.cloneNode(true));
      } else {
        dialogBody.innerHTML = template.innerHTML;
      }

      var idx = parseInt(btn.dataset.skincareStepIndex, 10);
      if (!isNaN(idx)) {
        dialogBody.dataset.currentStepIndex = String(idx);
      }

      lastTrigger = btn;
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t === btn ? 'true' : 'false');
      });

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      dialogBody.innerHTML = '';
      delete dialogBody.dataset.currentStepIndex;
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openFromTrigger(btn);
      });
    });

    bindDialogActions(section, dialog, dialogBody, triggers, openFromTrigger, advisorApi.openAdvisor);

    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-skincare-step-dialog-close]')) {
        e.preventDefault();
        closeDialog();
        return;
      }
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', function () {
      dialogBody.innerHTML = '';
      delete dialogBody.dataset.currentStepIndex;
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dialog.open) closeDialog();
    });
  }

  function init() {
    document.querySelectorAll('.section-oleum-skincare-steps').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('section-oleum-skincare-steps')) {
      initSection(el);
    }
  });
})();
